import React from 'react';

const About = () => (
	<div class='mt-5'>
		<section class='container'>
			<h1>This is the About Page</h1>
		</section>
	</div>
);

export default About;
